import * as React from "react";
import { StyleSheet, TouchableOpacity } from "react-native";
import { useNavigation } from "@react-navigation/native";
import { Ionicons } from "@expo/vector-icons";

export default function MainMenu() {
  const navigation = useNavigation();
  return (
    <TouchableOpacity
      style={styles.iconContainer}
      onPress={() => navigation.goBack()}
      //onPress={() => navigation.popToTop()}
    >
      <Ionicons name="md-arrow-back" size={20} color={"#ffffff"}/>
    </TouchableOpacity>
  );
}
const styles = StyleSheet.create({
  iconContainer: {
    paddingLeft: 15,
    paddingRight: 30,
  },
});
